var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5301_79518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.62285 2.94971C3.62221 2.94971 3.6215 2.94971 3.62086 2.94971C3.39678 2.94971 3.18602 3.03706 3.02687 3.1958C2.86597 3.35631 2.77734 3.57002 2.77734 3.79753V16.5104C2.77734 16.9766 3.1581 17.3568 3.6262 17.358C5.59961 17.3627 8.90586 17.774 11.1867 20.1609V6.85648C11.1867 6.69845 11.1463 6.54999 11.0702 6.42714C9.19814 3.41239 5.60073 2.95433 3.62285 2.94971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9132 16.5105V3.79753C20.9132 3.57002 20.8246 3.35631 20.6637 3.1958C20.5045 3.03706 20.2936 2.94971 20.0698 2.94971C20.069 2.94971 20.0683 2.94971 20.0677 2.94971C18.0899 2.95441 14.4925 3.41247 12.6204 6.42722C12.5442 6.55007 12.5039 6.69853 12.5039 6.85656V20.1609C14.7848 17.774 18.091 17.3627 20.0644 17.358C20.5324 17.3568 20.9132 16.9766 20.9132 16.5105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8448 5.88184H22.2301V16.5108C22.2301 17.7011 21.2603 18.6717 20.0682 18.6746C18.3943 18.6786 15.6344 19.0059 13.6797 20.8559C17.0603 20.0282 20.624 20.5663 22.655 21.0291C22.9086 21.0868 23.1707 21.0272 23.3739 20.8652C23.5763 20.7037 23.6925 20.4622 23.6925 20.203V6.7295C23.6926 6.26211 23.3122 5.88184 22.8448 5.88184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46239 16.5108V5.88184H0.847661C0.380355 5.88184 0 6.26211 0 6.7295V20.2028C0 20.4621 0.116149 20.7035 0.318611 20.865C0.521631 21.0269 0.783444 21.0868 1.03744 21.0288C3.06844 20.5659 6.63227 20.0279 10.0127 20.8557C8.05812 19.0057 5.29816 18.6785 3.6243 18.6745C2.43226 18.6717 1.46239 17.7011 1.46239 16.5108Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5301_79518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.6923,
    height: 23.6923,
    fill: "white",
    transform: "translate(0 0.153809)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookWhite);
export default __webpack_public_path__ + "static/media/book-white.b4ec260f.svg";
export { ForwardRef as ReactComponent };